// @flow

// popular/valid email domains based on this list:
// https://docs.google.com/spreadsheets/d/1HoMHP2hlfPtJDiqRyr-Dg5o4ZNGpHxKW5jK5qH_iN7E/edit#gid=400706363

export default [
  'gmail.com',
  'hotmail.com',
  'hotmail.com.ar',
  'yahoo.com.ar',
  'live.com.ar',
  'outlook.com',
  'live.com',
  'bigpond.com',
  'yahoo.com',
  'icloud.com',
  'yahoo.com.au',
  'yahoo.com.br',
  'bol.com.br',
  'yahoo.ca',
  'hotmail.ca',
  'web.de',
  'gmx.de',
  't-online.de',
  'hotmail.de',
  'hotmail.es',
  'yahoo.es',
  'hotmail.fr',
  'orange.fr',
  'yahoo.fr',
  'live.fr',
  'free.fr',
  'laposte.net',
  'wanadoo.fr',
  'outlook.fr',
  'hotmail.co.uk',
  'rediffmail.com',
  'yahoo.co.in',
  'yahoo.in',
  'libero.it',
  'hotmail.it',
  'alice.it',
  'yahoo.co.jp',
  'ezweb.ne.jp',
  'docomo.ne.jp',
  'i.softbank.jp',
  'softbank.ne.jp',
  'live.com.mx',
  'outlook.es',
  'aol.com',
  'outlook.com',
  'comcast.net',
];
